// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__11-kx","list":"styles_list__3laKq"};